import React from "react";
import {Switch} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {Observer, SubNavBar_Auto} from "web-vcore";
import {MeID} from "../Server/DB/users.js";
import {HasModPermissions} from "../Server/DB/users/$user.js";
import {store} from "../Store/index.js";
import {ConfigUI} from "./Engine/Config.js";
import {JourneyUI} from "./Engine/Journey.js";
import {LightsUI} from "./Engine/Lights.js";
import {ScriptsUI} from "./Engine/Scripts.js";
import {ShakesUI} from "./Engine/Shakes.js";
import {SoundsUI} from "./Engine/Sounds.js";
import {observer_mgl} from "mobx-graphlink";

export const columnWidths = [.64, .06, .12, .18];

export const EnginePage = observer_mgl(() => {
	const currentSubpage = store.main.engine.subpage;
	const page = "engine";
	//const subpages = pageTree.children[page].children.VValues();

	return (
		//<Column style={ES({flex: 1, background: "rgba(0,0,0,.8)"})}>
		<>
			<SubNavBar_Auto page={page} filter={a=>HasModPermissions(MeID()) || a.key != "training"}/>
			<Switch>
				{/*subpages.map((subpage, index)=>{
					if (index != 0 && currentSubpage != subpage.key) return null;
					return subpage.component;
				})*/}
				<ConfigUI/>
				{currentSubpage == "journey" && <JourneyUI/>}
				{currentSubpage == "sounds" && <SoundsUI/>}
				{currentSubpage == "shakes" && <ShakesUI/>}
				{currentSubpage == "lights" && <LightsUI/>}
				{currentSubpage == "scripts" && <ScriptsUI/>}
				{/*currentSubpage == "bundles" && <BundlesUI/>*/}
			</Switch>
		</>
	);
});
